import React from 'react'
import { NavLink } from 'react-router-dom'
import Footer from '../Components/Footer'
import Header from '../Components/Header'
function Hospitalmanagement() {
    return (
        <div>
            <Header />
            <div className="breadcrumbs overlay">
                <div className="container">
                    <div className="bread-inner">
                        <div className="row">
                            <div className="col-12">
                                <h2>Hospital Management</h2>
                                <ul className="bread-list">
                                    <li><NavLink to='/'>Pricing</NavLink></li>
                                    <li><i className="icofont-simple-right" /></li>
                                    <li className="active">Hospital Management</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="pricing-table section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2>Hospital Management Software </h2>
                                <img src="img/section-img.png" alt="#" />
                                <p>WEBNET-HMS hospital module is a web-based online hospital management software designed for Hospital, Clinic, Diagnostic Centre, Individual Doctors, Physicians as well as Multi-Specialty Hospitals. Designed to make the hospital management easy, as much as paperless, user-friendly, efficient and time-saving.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2>Explore Our Features</h2>
                                <p>It's a complete healthcare solution which provides an efficient workflow.</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-12 col-12" >
                            <div className="single-table" style={{ height: '310px', borderRadius: '50px 0px 50px 0px', borderLeft: '3px solid #2A4759', borderTop: '3px solid #2A4759' }}>
                                <div className="table-head">
                                    <div className="icon">

                                        <img src="Icon/OPD.png" alt="HospitalIcon" style={{ width: '50px', height: '50px' }} />
                                    </div>


                                    <h4 className="title">OUTPATIENTS (OPD)</h4>
                                    <div className="price">
                                        <p className="amount">Patient's registration, receive a consultation, investigation payment, track due payment, view patient's past medical records.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-3 col-md-12 col-12">
                            <div className="single-table" style={{ height: '310px', borderRadius: '50px 0px 50px 0px', borderLeft: '3px solid #2A4759', borderTop: '3px solid #2A4759' }}>
                                <div className="table-head">
                                    <div className="icon">

                                        <img src="Icon/IPD.png" alt="HospitalIcon" style={{ width: '50px', height: '50px' }} />

                                    </div>
                                    <h4 className="title">INPATIENTS (IPD)</h4>
                                    <div className="price">
                                        <p className="amount">Patient admission/discharge/transfer, allocate bed/ward/cabin, patient information, pathology bill, hospital bill, pharmacy bill and dues.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-3 col-md-12 col-12">
                            <div className="single-table" style={{ height: '310px', borderRadius: '50px 0px 50px 0px', borderLeft: '3px solid #2A4759', borderTop: '3px solid #2A4759' }}>
                                <div className="table-head">
                                    <div className="icon">

                                        <img src="Icon/prescription.png" alt="HospitalIcon" style={{ width: '50px', height: '50px' }} />
                                    </div>
                                    <h4 className="title">DOCTOR PRESCRIPTION</h4>
                                    <div className="price">
                                        <p className="amount">Patient list & reports, appointment schedule, faster e-prescription system, previous prescription, past medical records.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-3 col-md-12 col-12">
                            <div className="single-table" style={{ height: '310px', borderRadius: '50px 0px 50px 0px', borderLeft: '3px solid #2A4759', borderTop: '3px solid #2A4759' }}>
                                <div className="table-head">
                                    <div className="icon">
                                        <img src="Icon/PATHOLOGY.png" alt="HospitalIcon" style={{ width: '50px', height: '50px' }} />

                                    </div>
                                    <h4 className="title">PATHOLOGY & RADIOLOGY</h4>
                                    <div className="price">
                                        <p className="amount">Receive investigation requests, collect samples, faster result entry, deliver reports based on payment status, notification for reagent stock.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-3 col-md-12 col-12">
                            <div className="single-table" style={{ height: '310px', borderRadius: '50px 0px 50px 0px', borderLeft: '3px solid #2A4759', borderTop: '3px solid #2A4759' }}>
                                <div className="table-head">
                                    <div className="icon">

                                        <img src="Icon/pharmacy.png" alt="HospitalIcon" style={{ width: '50px', height: '50px' }} />

                                    </div>
                                    <h4 className="title">PHARMACY MANAGEMENT</h4>
                                    <div className="price">
                                        <p className="amount">Medicine information, alert for expired medicine, low stock notification, gross profit reports, store management, sales report.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-3 col-md-12 col-12">
                            <div className="single-table" style={{ height: '310px', borderRadius: '50px 0px 50px 0px', borderLeft: '3px solid #2A4759', borderTop: '3px solid #2A4759' }}>
                                <div className="table-head">
                                    <div className="icon">

                                        <img src="Icon/accounting.png" alt="HospitalIcon" style={{ width: '50px', height: '50px' }} />

                                    </div>
                                    <h4 className="title">ACCOUNTING</h4>
                                    <div className="price">
                                        <p className="amount">General ledger, accounts payable & receivable, chart of accounts, balance sheet, profit & loss, daybook, cashbook, bankbook.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-3 col-md-12 col-12">
                            <div className="single-table" style={{ height: '310px', borderRadius: '50px 0px 50px 0px', borderLeft: '3px solid #2A4759', borderTop: '3px solid #2A4759' }}>
                                <div className="table-head">
                                    <div className="icon">

                                        <img src="Icon/public-relation.png" alt="HospitalIcon" style={{ width: '50px', height: '50px' }} />

                                    </div>
                                    <h4 className="title">CLIENT/VENDOR MANAGEMENT</h4>
                                    <div className="price">
                                        <p className="amount">Easily manage your client/vendor from one place. Manage client/vendor profile, easily find out their payment information as well.</p>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="col-lg-3 col-md-12 col-12">
                            <div className="single-table" style={{ height: '310px', borderRadius: '50px 0px 50px 0px', borderLeft: '3px solid #2A4759', borderTop: '3px solid #2A4759' }}>
                                <div className="table-head">
                                    <div className="icon">

                                        <img src="Icon/inventory.png" alt="HospitalIcon" style={{ width: '50px', height: '50px' }} />


                                    </div>
                                    <h4 className="title">INVENTORY MANAGEMENT</h4>
                                    <div className="price">
                                        <p className="amount">Accurate inventory management with expiry control and physical stock auditing to ensure optimum stocks availability.</p>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="container mt-5">
                            <div className="row align-items-center">
                                {/* Left side content */}
                                <div className="col-lg-6 col-12">
                                    <div className="vision-content">
                                        <h4 style={{ color: '#007bff', marginBottom: '20px' }}>OUTPATIENT DEPARTMENT (OPD)</h4>
                                        <p style={{ color: 'black', textAlign: 'justify' }}>The Outpatient Department (OPD) is the first point of contact for patients seeking medical consultation without the need for hospital admission. It is designed to provide efficient and timely healthcare services to individuals with non-emergency conditions or those requiring follow-up treatment.</p>
                                        <ul className="list-unstyled mt-3" style={{ color: 'black' }} >
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                General Medical Consultations
                                            </li>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>Specialist Clinics (Cardiology, Orthopedics, ENT, Dermatology, etc.)
                                            </li>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                Diagnostic Services (X-ray, ECG, Laboratory Tests)
                                            </li>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                Preventive Health Checkups

                                            </li>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                Minor Procedures & Dressings

                                            </li>
                                        </ul>

                                    </div>
                                </div>

                                {/* Right side image */}
                                <div className="col-lg-6 col-12">
                                    <div className="vision-image">
                                        <img src="img/Opd.jpg" alt="Laboratory" style={{ width: '100%', height: 'auto', borderRadius: '0 20px 0 20px' }} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container mt-5">
                            <div className="row align-items-center">
                                {/* Right side image */}
                                <div className="col-lg-6 col-12">
                                    <div className="vision-image">
                                        <img src="img/IPD.jpg" alt="Laboratory" style={{ width: '100%', height: 'auto', borderRadius: '0 20px 0 20px' }} />
                                    </div>
                                </div>
                                {/* Left side content */}
                                <div className="col-lg-6 col-12">
                                    <div className="vision-content">
                                        <h4 style={{ color: '#007bff', marginBottom: '20px' }}>INPATIENT DEPARTMENT (IPD)</h4>
                                        <p style={{ color: 'black', textAlign: 'justify' }}>The Inpatient Department (IPD) provides care and treatment to patients who require admission to the hospital for continuous monitoring, surgery, complex medical management, or recovery under medical supervision. Our IPD services are designed to ensure patient safety, comfort, and quick recovery.</p>


                                    </div>
                                </div>


                            </div>
                        </div>

                        <div className="container mt-5">
                            <div className="row align-items-center">
                                {/* Left side content */}
                                <div className="col-lg-6 col-12">
                                    <div className="vision-content">
                                        <h4 style={{ color: '#007bff', marginBottom: '20px' }}>PATHOLOGY & RADIOLOGY</h4>
                                        <p style={{ color: 'black', textAlign: 'justify' }}>The Pathology & Radiology departments are the backbone of accurate diagnosis and effective treatment planning. Equipped with advanced technology and led by experienced specialists, these departments provide critical support to clinicians by delivering precise and timely diagnostic results</p>
                                        <ul className="list-unstyled mt-3" style={{ color: 'black' }}>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '5px' }}>➤</span>
                                                Clinical Pathology (Urine, Stool, and Body Fluids)
                                            </li>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '5px' }}>➤</span>Hematology (CBC, ESR, Blood Grouping, Coagulation Tests)
                                            </li>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '5px' }}>➤</span>
                                                Biochemistry (Liver Function Tests, Kidney Function Tests, Lipid Profile)
                                            </li>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '5px' }}>➤</span>
                                                Microbiology (Culture & Sensitivity, Infectious Disease Testing)

                                            </li>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '5px' }}>➤</span>
                                                Histopathology & Cytology (Biopsy, FNAC, PAP Smear)

                                            </li>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '5px' }}>➤</span>
                                                Immunology & Serology (HIV, Hepatitis, RA Factor, CRP, etc.)
                                            </li>
                                        </ul>

                                    </div>
                                </div>

                                {/* Right side image */}
                                <div className="col-lg-6 col-12">
                                    <div className="vision-image">
                                        <img src="img/radiology.png" alt="Laboratory" style={{ width: '100%', height: 'auto', borderRadius: '0 20px 0 20px' }} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container mt-5">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-12">
                                    <div className="vision-image">
                                        <img src="img/vendorcliient.jpg" alt="Laboratory" style={{ width: '100%', height: 'auto', borderRadius: '0 20px 0 20px' }} />
                                    </div>
                                </div>
                                {/* Left side content */}
                                <div className="col-lg-6 col-12">
                                    <div className="vision-content">
                                        <h4 style={{ color: '#007bff', marginBottom: '20px' }}>CLIENT / VENDOR MANAGEMENT</h4>
                                        <p style={{ color: 'black', textAlign: 'justify' }}>Client and Vendor Management is essential for ensuring smooth operations, service quality, and regulatory compliance within the hospital or healthcare system. This department is responsible for onboarding, maintaining, and overseeing relationships with external service providers and institutional clients.</p>


                                    </div>
                                </div>

                                {/* Right side image */}

                            </div>
                        </div>


                        <div className="container mt-5">
                            <div className="row align-items-center">

                                {/* Left side content */}
                                <div className="col-lg-6 col-12">
                                    <div className="vision-content">
                                        <h4 style={{ color: '#007bff', marginBottom: '20px' }}>INVENTORY MANAGEMENT</h4>
                                        <p style={{ color: 'black', textAlign: 'justify' }}>Take complete control of your stock with Webnet Care’s Inventory Management System  a smart, reliable, and efficient way to manage your goods, reduce wastage, and optimize operations.

                                            Whether you're running a hospital, retail business, warehouse, or service center, our inventory solution is built to track every item in real-time and ensure you're never understocked or overstocked again.</p>


                                    </div>
                                </div>
                                <div className="col-lg-6 col-12">
                                    <div className="vision-image">
                                        <img src="img/inventory-management-system.png" alt="Laboratory" style={{ width: '100%', height: 'auto', borderRadius: '0 20px 0 20px' }} />
                                    </div>
                                </div>
                                {/* Right side image */}

                            </div>
                        </div>



                        <section className="vision-section section">
                            <div className="container">
                                <div className="row align-items-center">
                                    {/* Right side image */}
                                    <div className="col-lg-6 col-12">
                                        <div className="vision-image">
                                            <img src="img/laboratory.jpeg" alt="Laboratory" style={{ width: '100%', height: 'auto', borderRadius: '0 20px 0 20px' }} />
                                        </div>
                                    </div>

                                    {/* Left side content */}
                                    <div className="col-lg-6 col-12">
                                        <div className="vision-content">
                                            <h4 style={{ color: '#007bff', marginBottom: '20px' }}>LABORATORY MANAGEMENT </h4>
                                            <p style={{ color: 'black', textAlign: 'justify' }}>Providing high-quality patient care is critical for any hospital laboratory. It enables laboratories to record, manage & store critical pathological data of the patient.</p>
                                            <ul className="list-unstyled mt-3" style={{ color: 'black' }}>
                                                <li>
                                                    <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                    Inventory management
                                                </li>
                                                <li>
                                                    <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>Data management
                                                </li>
                                                <li>
                                                    <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                    Patient management

                                                </li>
                                                <li>
                                                    <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                    Billing management

                                                </li>
                                                <li>
                                                    <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                    Analytics & Reports

                                                </li>
                                            </ul>

                                        </div>
                                    </div>




                                </div>
                            </div>
                        </section>
                        <div className="container">
                            <div className="row align-items-center">
                                {/* Right side image */}



                                {/* Left side content */}
                                <div className="col-lg-6 col-12">
                                    <div className="vision-content">
                                        <h4 style={{ color: '#007bff', marginBottom: '20px' }}>OT MANAGEMENT </h4>
                                        <p style={{ color: 'black', textAlign: 'justify' }}>Customized comprehensive operation theatre management system enabling the hospital to schedule patients and clinicians, ensuring patient safety and improve operation theatre and staff utilization.</p>
                                        <ul className="list-unstyled mt-3" style={{ color: 'black' }}>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                Booking management
                                            </li>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>Staff management
                                            </li>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                Patient information

                                            </li>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                Billing management

                                            </li>
                                            <li>
                                                <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                Report & analytics


                                            </li>
                                        </ul>

                                    </div>
                                </div>

                                <div className="col-lg-6 col-12">
                                    <div className="vision-image">
                                        <img src="img/OT.jpeg" alt="OT" style={{ width: '100%', height: 'auto', borderRadius: '0 20px 0 20px' }} />
                                    </div>
                                </div>


                            </div>
                        </div>

                        <section className="vision-section section">
                            <div className="container">
                                <div className="row align-items-center">

                                    {/* Right side image */}
                                    <div className="col-lg-6 col-12">
                                        <div className="vision-image">
                                            <img src="img/Finance.jpeg" alt="finance" style={{ width: '100%', height: 'auto', borderRadius: '20px 0px 20px 0px' }} />
                                        </div>
                                    </div>

                                    {/* Left side content */}
                                    <div className="col-lg-6 col-12">
                                        <div className="vision-content">
                                            <h4 style={{ color: '#007bff', marginBottom: '20px' }}>Finance & Accounting Management </h4>
                                            <p style={{ color: 'black', textAlign: 'justify' }}>This module will automate the entire billing & accounting of the entire hospital operations finances. This module will enable hospitals to capitalize on new opportunities, manage daily purchase or sales, transactions, expenses, balance sheets etc.</p>
                                            <ul className="list-unstyled mt-3" style={{ color: 'black' }}>
                                                <li>
                                                    <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                    Accounting & Finances

                                                </li>
                                                <li>
                                                    <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                    Revenue management

                                                </li>
                                                <li>
                                                    <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                    Reporting & analytics

                                                </li>
                                                <li>
                                                    <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                    Inventory

                                                </li>
                                                <li>
                                                    <span role="img" aria-label="arrow" style={{ marginRight: '10px' }}>➤</span>
                                                    Procurement

                                                </li>
                                            </ul>

                                        </div>
                                    </div>




                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </section >
            <Footer />
        </div >
    )
}

export default Hospitalmanagement
